import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
interface UseGetDistributionJobsSimulateProps {
  communityId: string;
  jobId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionJobsSimulate = async (jobId: string, communityId: string) =>
  await axiosAuth.post(`${DISTRIBUTION_JOBS_API(communityId)}/${jobId}/simulate`);

const useGetDistributionJobsSimulate = ({
  queryParams,
  jobId,
  communityId
}: UseGetDistributionJobsSimulateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-jobs-simulate", jobId],
    queryFn: () => getDistributionJobsSimulate(jobId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!jobId && (queryParams?.enabled ?? true),
  });
};

export default useGetDistributionJobsSimulate;
